export default {
  meta: {
    title: '客流计数-点位详情',
  },
};
